import { type LayoutData } from '@blaze-runtime/engine-domain';
import { getRemovedWorkflowIds } from '@blaze-runtime/engine-domain';
import { type WorkflowsToRemoveInfo } from '@blaze-shared/api-contracts-domain';
import { type Connection } from '@blaze-shared/workflow-domain';

import { type LayoutsApiDataRequest } from '../../../data/layouts-api.service';
/** Check if there are workflows which were connected and are no longer connected
  Disconnected workflows should be removed */
export function getLayoutWorkflowsToRemove(
  layoutsSaveData: LayoutsApiDataRequest[],
  connectionsByLayout: Record<string, Connection[]>,
  layoutEntities: Record<string, LayoutData>,
): WorkflowsToRemoveInfo[] {
  const workflowsToRemove: WorkflowsToRemoveInfo[] = [];
  layoutsSaveData.forEach(({ pageId }) => {
    const layoutConnections = connectionsByLayout[pageId] || [];
    const savedLayoutConnections = layoutEntities[pageId].actionLayer?.connections;

    // Get all workflow ids that were disconnected (previously connected but not anymore)
    const removedWorkflowIds = getRemovedWorkflowIds(savedLayoutConnections, layoutConnections);
    if (removedWorkflowIds.length > 0) {
      workflowsToRemove.push({ pageId, workflowIds: removedWorkflowIds });
    }
  });
  return workflowsToRemove;
}
